/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { Tab as OriginalTab } from '@fiverr-private/navigation';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';
import withClick from '../helpers/withClick';

const Tab = forwardRef(({ children, ...props }, ref) => {
    const context = useParentPropsOverrideContext();

    return (
        <OriginalTab ref={ref} {...props} {...context}>
            {children}
        </OriginalTab>
    );
});

export default withClick(Tab);
